// extracted by mini-css-extract-plugin
export default {"navbar":"App_navbar__J-WCx","logo":"App_logo__9xoKS","links":"App_links__6ssyp","link":"App_link__rWkE4","main":"App_main__Ouif1","footer":"App_footer__FwuVS"};